export default __webpack_public_path__ + "static/media/3.f0f046c5.jpg";